<template>
  <v-card outlined max-width="380" class="mb-5">
    <v-card-subtitle class="pb-0"> ライター </v-card-subtitle>
    <v-card-text class="pt-0">
      <v-row align="center" class="pb-0">
        <v-col cols="2">
          <v-avatar v-if="writerAvatarUrl !== null && writer.displayCommonInformation == true" size="36" justify="center">
            <img :src="writerAvatarUrl" alt="NoImage" />
          </v-avatar>
          <v-avatar v-else size="36">
            <v-icon>mdi-account-circle</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="10" class="pt-0 pb-0">
          <v-select
            v-model="writer"
            :items="selectableWriters"
            item-text="name"
            hide-selected
            :disabled="mode == 'readonly'"
            clearable
            return-object
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  name: 'Writer',
  data: () => {
    return {
      selectableWriters: [],
      writerAvatarUrl: null
    }
  },
  computed: {
    ...mapState({
      mode: (state) => state.PostEditor.mode
    }),
    writer: {
      get () {
        return this.$store.state.PostEditor.post.writerable
      },
      set (writer) {
        if (writer) {
          this.writerAvatarUrl = writer.avatar.url ? writer.avatar.url : null
        } else {
          this.writerAvatarUrl = null
        }
        return this.$store.commit('PostEditor/UPDATE_WRITERABLE', writer)
      }
    }
  },
  created: function () {
    if (this.$store.state.PostEditor.post.writerable == null) {
      this.writerAvatarUrl = null
    } else if (
      this.$store.state.PostEditor.post.writerable.avatar.url !== null
    ) {
      this.writerAvatarUrl = this.$store.state.PostEditor.post.writerable.avatar.url
    }
  },
  mounted: function () {
    const contributorsRequest = axios.get('/api/contributors')
    const writersRequest = axios.get('/api/users', { params: { role: 'writer' } })
    const adminsRequest = axios.get('/api/admin_users')
    axios
      .all([contributorsRequest, writersRequest, adminsRequest])
      .then(
        axios.spread((...responses) => {
          responses[0].data.data.forEach(({ attributes }) => {
            attributes = Object.assign(attributes, { type: 'Contributor' })
            this.selectableWriters.push(attributes)
          })
          responses[1].data.data.forEach(({ attributes }) => {
            attributes = Object.assign(attributes, { type: 'User' })
            this.selectableWriters.push(attributes)
          })
          responses[2].data.data.forEach(({ attributes }) => {
            attributes = Object.assign(attributes, { type: 'User' })
            this.selectableWriters.push(attributes)
          })
        })
      )
      .catch((error) => console.error(error))
  }
}
</script>

<style scoped></style>
